import { WishlistApp } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.21.1/wishlist-app.js";

export const createApp = ({ settings, config, locale }) => {
  if (window.WishlistKing) {
    return;
  }

  const app = new WishlistApp({
    config,
    settings,
    locale,
    dependencies: [
      "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.21.1/components/wishlist.css",
      "//www.pulltheplugpatches.com/cdn/shop/t/24/assets/wishlist-king-custom.css?v=105007065398654067971732330184",
      "//www.pulltheplugpatches.com/cdn/shop/t/24/assets/wishlist-king-components.js?v=77036023704446679651732330184",
    ],
  });

  initEvents(app);
  initComponents(app);

  return app;
};

const initComponents = ({ theme, routes }) => {
  // Header link
  theme.watch(
    {
      selector: ".header__icon--cart",
    },
    (target) => {
      target.insertBefore(
        theme.createComponent("wishlist-link", {
          props: {
            layout: "icon-only",
            alignment: "center",
            // badgeLayout: "pill-and-text",
            // badgeParentheses: false,
            // badgeHiddenIfEmpty: true,
            // badgeFloating: {
            //   referenceName: "icon",
            //   position: {
            //     placement: "bottom-end",
            //     inset: true,
            //   },
            //   offset: 0,
            // },
          },
        })
      );
    }
  );

  // Grid items
  theme.watch(
    {
      selector: `.product-card-wrapper [href*="/products/"]`,
      pageType: ["home", "product", "collection"],
    },
    (target) => {
      target.element?.parentElement?.parentElement?.appendChild(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(target.element.href),
            variantId: theme.getVariantId(target.element.href),
          },
          props: {
            layout: "icon-only",
            alignment: "center",
            // floating: {
            //   reference: target,
            //   position: {
            //     placement: "top-end",
            //     inset: true,
            //   },
            //   offset: 0,
            // },
          },
        })
      );
    }
  );

  // Product page
  theme.watch(
    {
      selector: `.product-form__buttons`,
      pageType: ["product"],
    },
    (target) => {
      target.append(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(document.location.href),
            variantId: theme.getVariantId(document.location.href),
          },
          props: {
            layout: "icon-and-text",
            alignment: "center",
            fullWidth: true,
            outline: false,
          },
        })
      );
    }
  );

  theme.watch(
    {
      selector: `.coming-soon-message`,
      pageType: ["product"],
    },
    (target) => {
      target.append(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(document.location.href),
            variantId: theme.getVariantId(document.location.href),
          },
          props: {
            layout: "icon-and-text",
            alignment: "center",
            fullWidth: true,
            outline: false,
          },
        })
      );
    }
  );

  // Wishlist page
  theme.watch(
    {
      selector: "#wishlist-page",
    },
    (target) => {
      target.replace(
        theme.createComponent("wishlist-page", {
          dataset: {
            wishlistId: theme.getWishlistId(window.location.pathname),
          },
        })
      );
    }
  );
};

const initEvents = (app) => {
  app.events.subscribe("wk:wishlist:add-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:add-all-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:cart:save-for-later:success", (event) => {
    // event.data.trigger
    //   .closest(".xxx-cart-item-xxx")
    //   .querySelector("xxx-cart-remove-button-xxx")
    //   .click();
  });
  app.events.subscribe("wk:wishlist:login-required", (event) => {
    const ignoreActions = ["wishlist:private:load"];
    if (!ignoreActions.includes(event.data.action)) {
      window.location.href = app.routes.accountLoginUrl;
    }
  });
};
